import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** Response of POST /assignments/restart-failed. */
export interface RestartFailedAssignmentsResult {
  processKey: string | null;
  requested: number;
  changed: number;
  skipped: number;
}

/**
 * Batch restart of Failed assignments.
 * TODO: migrate to api-client when POST /assignments/restart-failed is generated.
 */
@Injectable({ providedIn: 'root' })
export class RestartFailedAssignmentsService {
  private readonly http = inject(HttpClient);

  restart(processKey?: string | null): Observable<RestartFailedAssignmentsResult> {
    let params = new HttpParams();
    const key = processKey?.trim();
    if (key) {
      params = params.set('processKey', key);
    }
    return this.http.post<RestartFailedAssignmentsResult>(
      `${environment.api}/assignments/restart-failed`,
      null,
      { params },
    );
  }
}
